import React, { createContext, useContext, useEffect, useState } from "react";

const TimezoneContext = createContext(null);
export const useTimezone = () => useContext(TimezoneContext);

export const TIMEZONES = [
  { tz: "Europe/London", label: "London" },
  { tz: "Europe/Dublin", label: "Dublin" },
  { tz: "Europe/Lisbon", label: "Lisbon" },
  { tz: "Europe/Berlin", label: "Berlin" },
  { tz: "Europe/Paris", label: "Paris" },
  { tz: "Europe/Madrid", label: "Madrid" },
  { tz: "Europe/Amsterdam", label: "Amsterdam" },
  { tz: "Europe/Athens", label: "Athens" },
  { tz: "Europe/Helsinki", label: "Helsinki" },
  { tz: "Europe/Prague", label: "Prague" },
  { tz: "Europe/Copenhagen", label: "Copenhagen" },
  { tz: "UTC", label: "UTC" },
  { tz: "America/New_York", label: "New York" },
  { tz: "America/Chicago", label: "Chicago" },
  { tz: "America/Los_Angeles", label: "Los Angeles" },
  { tz: "America/Toronto", label: "Toronto" },
  { tz: "Asia/Dubai", label: "Dubai" },
  { tz: "Asia/Kolkata", label: "Mumbai" },
  { tz: "Asia/Singapore", label: "Singapore" },
  { tz: "Australia/Sydney", label: "Sydney" },
  { tz: "Pacific/Auckland", label: "Auckland" },
];

export function tzLabel(tz) {
  return TIMEZONES.find((t) => t.tz === tz)?.label || tz;
}

export function TimezoneProvider({ children }) {
  const [tz, setTzState] = useState(() => localStorage.getItem("crm-tz") || "Europe/London");
  useEffect(() => { localStorage.setItem("crm-tz", tz); }, [tz]);
  const setTz = (t) => setTzState(t);
  return <TimezoneContext.Provider value={{ tz, setTz, label: tzLabel(tz) }}>{children}</TimezoneContext.Provider>;
}
